import React, { useState, useContext, useEffect } from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { AiOutlineEdit } from 'react-icons/ai';
import { ModalCtx } from '../../../contexts';


const Text = ( { label, db, value } ) => {
    const { setDraftValues } = useContext( ModalCtx );
    const [ v, setV ] = useState( value );

    useEffect( () => {
        setV( value );
    }, [ value ] );

    const handleDraft = ( e ) => {
        setV( e.target.value );
        setDraftValues( prevState => (
            {
                ...prevState,
                [e.target.id]: e.target.value
            }
        ) );
    }

    return (
        <Col>
            <Form.Group as={Row} className='tf-form-group align-items-center' controlId={db}>
                <Form.Label column xs='auto' className='col-md-auto p-0 fw-light'>{label}</Form.Label>
                <Col className='tf-form-text-field me-1'><Form.Control value={v} onChange={handleDraft} /></Col>
                {/* <Col className='tf-form-edit-icon' xs='auto'><AiOutlineEdit /></Col> */}
            </Form.Group>
        </Col>
    )
}

export default Text;